module.exports = __webpack_public_path__ + "static/media/logo-sidebar.56d8d675.svg";